import React, { Component } from 'react'
import Player from "../myStats/Player.js";

export default class About extends Component {
  render() {
    return (
      <div>
        <Player />
      </div>
    )
  }
}
